<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div class="container" style="margin-top:10px">
    <div class="row">
      <div class="col-12" style="width:100%"*ngIf="forum" >
          <div class="single-post">

              <!-- Post Content -->
              <div class="post-content">

                  <a>
                      <h2 class="post-headline">{{forum[0].title}}</h2>
                  </a>
                  <p style="overflow-wrap: break-word; font-style: open sans;
                  color:#9b7544; font-size:25px">{{forum[0].body}}</p>
                  <div class="post-meta d-flex" style="font-size:20px">
                      <div class="post-author-date-area d-flex">
                          <!-- Post Author -->
                          <div class="post-author">
                              <a href="#">By pet cart</a>
                          </div>
                          <!-- Post Date -->
                          <div class="post-date">
                              <a >{{forum[0].created_at | slice:0:10}}</a>
                          </div>
                      </div>
                      <!-- Post Comment & Share Area -->
                      <div class="post-comment-share-area d-flex">
                          <!-- Post Comments -->
                          <div class="post-comments">
                              <a href="#"><i class="fa fa-comment-o" aria-hidden="true"></i>{{totalcomment}}</a>
                          </div>
                          <!-- Post Share -->
                          <div class="post-share">
                              <a href="#"><i class="fa fa-share-alt" aria-hidden="true"></i></a>
                          </div>
                      </div>
                  </div>

                  <div class="comment_area section_padding_50 clearfix" style="border-top:2px solid #9b7544" *ngIf="comment && comment.length > 0">
                      <h4 class="mb-30">{{totalcomment}} Comments</h4>

                      <ol style="margin-top:30px;" >
                          <!-- Single Comment Area -->
                          <li class="single_comment_area" *ngFor=" let data of comment">
                              <div class="comment-wrapper d-flex">
                                  <!-- Comment Meta -->
                                  <div class="comment-author">
                                      <img src="https://passport.petcart.in/images/userimgs/{{userimgarray['id'+data.user_id]}}" alt="">
                                  </div>
                                  <!-- Comment Content -->
                                  <div class="comment-content">
                                      <span class="comment-date text-muted">{{data.updated_at | slice :10}}</span>
                                      <h5>{{usernamearray['id'+data.user_id]}}</h5>
                                      <p style="overflow-wrap: break-word; font-style: open sans;">{{data.comment}}</p>
                                  </div>
                              </div>
                          </li>
                      </ol>
                  </div>
                  <div class="leave-comment-area section_padding_50 clearfix" *ngIf="userStatus == 1 && userrole ==3">
                      <div class="comment-wrapper d-flex">
                      <div class="comment-author" *ngIf="mydata">
                          <img src="https://passport.petcart.in/images/userimgs/{{mydata[0].image}}" alt="">
                      </div>
                      <!-- Comment Content -->
                      <div class="comment-content" *ngIf="mydata">

                          <h5>{{mydata[0].name}}</h5>

                      </div>
                  </div>
                      <div class="comment-form">
                            <h4 class="mb-30">Leave A Comment</h4>

                            <!-- Comment Form -->
                            <form>
                                <div class="form-group">
                                    <textarea class="form-control" name="message" id="message"
                                    cols="30" rows="10" placeholder="Message" [(ngModel)]="message" required></textarea>
                                </div>
                                <button (click)="uploadComments()" class="btn btn-success contact-btn" *ngIf="message">Post Comment</button>
                            </form>
                        </div>
                    </div>
              </div>
          </div>
      </div>
    </div>
  </div>
